import { CloudCommand } from "../types.js";

export const getConversationMessages: CloudCommand = {
    action: "MESSAGE/GET_MESSAGES_FROM_CONVERSATION",
    commandName: "message.getConversationMessages",
    buildPayload: ({ params }) => params,
};
